import { useState, type ComponentProps } from 'react';
import { FieldInfo, hasFieldError, useFieldContext, useIsFieldOptional } from './shared';
import { FieldLabelRow } from './field-label-row';
import { Input } from '../input';
import { EyeIcon, EyeOffIcon } from 'lucide-react';

export default function PasswordField({
	label,
	className,
	...props
}: Omit<ComponentProps<'input'>, 'type'> & { label: string }) {
	const field = useFieldContext<string>();
	const [showPassword, setShowPassword] = useState(false);
	const isOptional = useIsFieldOptional(field.name);

	return (
		<div className={className}>
			<div className="grid gap-2">
				{label && (
					<FieldLabelRow
						label={label}
						htmlFor={field.name}
						hasError={field.state.meta.isTouched && !field.state.meta.isValid}
						optional={isOptional}
					/>
				)}
				<div className="relative">
					<Input
						id={field.name}
						name={field.name}
						aria-invalid={hasFieldError(field.state.meta)}
						type={showPassword ? 'text' : 'password'}
						value={field.state.value}
						onBlur={field.handleBlur}
						onChange={(e) => field.handleChange(e.target.value)}
						className="pr-10"
						{...props}
					/>
					<button
						type="button"
						onClick={() => setShowPassword(!showPassword)}
						className="text-muted-foreground hover:text-foreground absolute top-1/2 right-3 -translate-y-1/2 transition-colors"
						tabIndex={-1}
					>
						{showPassword ? <EyeOffIcon className="size-5" /> : <EyeIcon className="size-5" />}
					</button>
				</div>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
